import { DeleteForever, Edit, RemoveRedEye } from '@mui/icons-material';
import { Box, Button, CircularProgress, Container, Grid, Stack, Typography } from '@mui/material';
import axios from 'axios';
import moment from 'moment';
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import Page from '../components/Page';
import EditAuthor from '../components/EditAuthor';
import PopupDelete from '../components/popups/AuthorDelete';
import BackButton from '../components/BackButton';

export default function ViewAuthor() {
  const { id } = useParams();
  const [profile, setProfile] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(true);
  const [editMode, setEditMode] = React.useState(false);
  const [image, setImage] = React.useState(null);
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const getProfile = async () => {
    try {
      setIsLoading(true);
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/author`, {
        params: {
          id,
        },
      });
      console.log(res);
      setProfile(res.data.data);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const deleteAuthorPopup = () => {
    setOpen(true);
  };

  React.useEffect(() => {
    getProfile();
  }, []);

  return (
    <Page title="Author">
      {isLoading ? (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '50vh',
          }}
        >
          <CircularProgress />
        </div>
      ) : (
        <Container maxWidth="xl" sx={{ marginTop: '50px' }}>
          <Box
            sx={{
              width: '100%',
              height: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column',
            }}
          >
            <Grid
              container
              sx={{
                width: {
                  xs: '100%',
                  md: '85%',
                  lg: '85%',
                  xl: '80%',
                },
                borderRadius: '10px',
                boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px',
                position: 'relative',
              }}
            >
              <Box
                sx={{
                  position: 'absolute',
                  top: '20px',
                  right: '20px',
                }}
              >
                <BackButton />
              </Box>
              <Grid item xs={12} sm={6} md={5} lg={4} padding={2}>
                <Box
                  component="img"
                  height="250px"
                  width="250px"
                  sx={{
                    objectFit: 'contain',
                  }}
                  src={image || profile?.profilePic?.fileUrl || '/static/mock-images/avatars/avatar2.png'}
                  alt="profile pic"
                />
              </Grid>
              {!editMode && (
                <Grid item xs={12} sm={6} md={7} lg={8} padding={2}>
                  <Grid item xs={12}>
                    <Stack
                      direction="row"
                      alignItems="center"
                      justifyContent="space-between"
                      margin={1}
                      sx={{ width: '100%' }}
                    >
                      <Typography variant="h4" sx={{ minWidth: '300px' }} gutterBottom>
                        ACCOUNT DETAILS
                      </Typography>
                      {profile.isAdmin && (
                        <Stack direction="row" alignItems="center" justifyContent={'flex-end'} sx={{ width: '100%' }}>
                          <Button
                            sx={{ marginX: '20px' }}
                            onClick={() => {
                              navigate(`/dashboard/account/view/${profile?.adminId}`);
                            }}
                            startIcon={<RemoveRedEye />}
                            size="small"
                            color="primary"
                          >
                            Admin
                          </Button>
                        </Stack>
                      )}
                    </Stack>
                  </Grid>

                  <Stack
                    direction="column"
                    alignItems="center"
                    justifyContent="center"
                    sx={{ width: '100%' }}
                    marginLeft={2}
                  >
                    <Stack direction="row" alignItems="center" margin={1} sx={{ width: '100%' }}>
                      <Stack flex={1} justifyContent={'start'} alignItems="start">
                        <Typography>Name:</Typography>
                      </Stack>
                      <Stack flex={3} justifyContent={'start'} alignItems="start">
                        <Typography sx={{ fontWeight: 'bold' }}>{profile?.name}</Typography>
                      </Stack>
                    </Stack>
                    <Stack direction="row" alignItems="center" margin={1} sx={{ width: '100%' }}>
                      <Stack flex={1} justifyContent={'start'} alignItems="start">
                        <Typography>Member Since:</Typography>
                      </Stack>
                      <Stack flex={3} justifyContent={'start'} alignItems="start">
                        <Typography sx={{ fontWeight: 'bold' }}>
                          {moment(profile.createdAt).format('MMM DD, YYYY')}
                        </Typography>
                      </Stack>
                    </Stack>
                    <Stack direction="row" alignItems="center" margin={1} sx={{ width: '100%' }}>
                      <Stack flex={1} justifyContent={'start'} alignItems="start">
                        <Typography>Status:</Typography>
                      </Stack>
                      <Stack flex={3} justifyContent={'start'} alignItems="start">
                        <Typography sx={{ fontWeight: 'bold' }}>
                          {profile?.isDisabled ? 'Disabled' : 'Active'}
                        </Typography>
                      </Stack>
                    </Stack>
                  </Stack>
                </Grid>
              )}
              {!editMode && (
                <Grid item xs={12}>
                  {!profile.isAdmin && (
                    <Stack
                      direction="row"
                      alignItems="center"
                      justifyContent={'flex-end'}
                      sx={{ width: '100%' }}
                      spacing={2}
                      paddingX={2}
                      paddingBottom={2}
                    >
                      <Button
                        variant="outlined"
                        onClick={() => {
                          setEditMode(true);
                        }}
                        startIcon={<Edit />}
                        size="small"
                        color="success"
                      >
                        Edit
                      </Button>
                      {!profile?.isDefault && (
                        <Button
                          variant="outlined"
                          onClick={() => {
                            deleteAuthorPopup();
                          }}
                          startIcon={<DeleteForever />}
                          size="small"
                          color="error"
                        >
                          Delete
                        </Button>
                      )}
                      {open && <PopupDelete id={profile._id} handleClose={handleClose} />}
                    </Stack>
                  )}
                </Grid>
              )}

              {editMode && (
                <EditAuthor profile={profile} setEditMode={setEditMode} getProfile={getProfile} setImage={setImage} />
              )}
            </Grid>
          </Box>
        </Container>
      )}
    </Page>
  );
}
